import React from 'react'
import PropTypes from 'prop-types'
import api from 'services/pet-notify-api'
import InvitationPetParentEmailAcceptedScreen from 'ContactApp/screens/Invitation-Pet-Parent-Email/Accepted'

class InvitationAcceptedPhoneScreenContainer extends React.PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        token: PropTypes.string,
      }),
    }),
  }

  state = {
    isLoading: true,
    error: '',
  }

  async componentDidMount() {
    const { match } = this.props
    const { params } = match
    const { token } = params

    try {
      const petParent = await api.petParentInvitations.view(token)
      if(petParent){
        this.setState({ isLoading: false, petParent, type: 'phone' })
      } else {
        this.setState({ isLoading: false, error: 'Pet parent not found' })
      }
    } catch (error) {
      this.setState({ isLoading: false, error })
    }
  }

  generateProps = () => ({
    ...this.props,
    ...this.state,
  })

  render() {
    const props = this.generateProps()

    return <InvitationPetParentEmailAcceptedScreen {...props} />
  }
}

export default InvitationAcceptedPhoneScreenContainer
